import React, {PropsWithChildren} from "react"

export default function DefaultLayout({children}: PropsWithChildren<{}>) {
	return <>{children}</>
}
